import type { Tone } from '../../ui/v2';
import { formatAdminCallCreatedAt } from './adminCallsModel';

export const SENT_NOTIFICATIONS_PAGE_SIZE = 20;

export interface SentNotification {
  id: number;
  store_id: number | null;
  store_name: string;
  contact_label: string;
  contact: string;
  channel: string;
  event_type: string;
  event_label: string;
  category: string;
  status: string;
  delivery_status: string;
  subject: string;
  body: string;
  sent_at: string | null;
  created_at: string | null;
  call_id: string | null;
  transcript: string;
}

export interface SentNotificationsPage {
  rows: SentNotification[];
  count?: number;
  totalPages?: number;
}

export const readSentNotificationsPage = (data: any): SentNotificationsPage => {
  if (data?.results && Array.isArray(data.results)) {
    return {
      rows: data.results,
      count: data.count || 0,
      totalPages:
        data.total_pages ||
        Math.ceil((data.count || 0) / SENT_NOTIFICATIONS_PAGE_SIZE),
    };
  }
  if (Array.isArray(data)) {
    return { rows: data, count: data.length, totalPages: 1 };
  }
  return { rows: [] };
};

export const sentNotificationWhen = (row: SentNotification) =>
  formatAdminCallCreatedAt(row.sent_at || row.created_at);

export const sentNotificationContact = (row: SentNotification) => {
  if (row.contact_label && row.contact) {
    return `${row.contact_label} · ${row.contact}`;
  }
  return row.contact_label || row.contact || '—';
};

export const sentNotificationEvent = (row: SentNotification) =>
  row.category || row.event_label || row.event_type || '—';

export const sentNotificationStatus = (row: SentNotification) => {
  if (row.delivery_status && row.delivery_status !== 'unknown') {
    return row.delivery_status;
  }
  return row.status || '—';
};

export const sentNotificationStatusTone = (status: string): Tone => {
  if (status === 'sent' || status === 'delivered' || status === 'accepted') {
    return 'success';
  }
  if (status === 'failed' || status === 'bounced' || status === 'complained') {
    return 'danger';
  }
  if (status === 'sending' || status === 'pending') return 'warning';
  return 'neutral';
};

export const sentNotificationPreview = (body: string) => {
  const line = body.replace(/\s+/g, ' ').trim();
  if (!line) return '—';
  return line.length > 90 ? `${line.slice(0, 87)}…` : line;
};
